import dayjs from 'dayjs';
import { getCookie } from '../utils';
import { ALLROUTES } from '../constants/routes';

import config from '../package.json';
export default {
  mounted() {
    if (process.env.LOGAN_REPORT) {
      return;
    }
    // 每次进入页面生成sqeuenceNumber,初始化为0
    this.initSqeuenceNumber();
    // Page Start
    this.logPageStartOrEnd('Page Start');
    // 监听刷新或者关闭页面

    window.addEventListener('beforeunload', (event) => {
      // Cancel the event as stated by the standard.
      event.preventDefault();
      // Chrome requires returnValue to be set.
      // 页面刷新记录当前页面关闭
      const routeName = name ? name : this.$route.name;
      this.logPageStartOrEnd('Page End', routeName);
      this.reportLog();
      // event.returnValue = '';
    });
  },
  watch: {
    $route: {
      handler(to, from) {
        if (process.env.LOGAN_REPORT) {
          return;
        }
        // 路由切换的时候，记录页面离开Page End，然后上报日志，接口记录新页面的开始
        this.logPageStartOrEnd('Page End', from.name);
        this.reportLog();
        this.logPageStartOrEnd('Page Start', to.name);
      },
      deep: true,
    },
  },
  methods: {
    // 初始化 sqeuenceNumber
    initSqeuenceNumber() {
      // 如果 sqeuenceNumber 不存在，则初始化为0
      const sqeuenceNumber = sessionStorage.getItem('sqeuenceNumber');
      if (sqeuenceNumber === null) {
        sessionStorage.setItem('sqeuenceNumber', 0);
        // 第一次进入上报session日志
        this.logSession();
      }
    },
    logSession() {
      // 用户uuid
      const uuid = getCookie('g_traceId');
      // 当前会话ID
      const sessionId = getCookie('g_conversationId');
      const data = `web,${config.version},${uuid},${sessionId}`;
      this.$Logan.log(data, 0);
    },
    // 记录页面开始和结束
    logPageStartOrEnd(type, name) {
      const sqeuenceNumber = +sessionStorage.getItem('sqeuenceNumber');
      const sessionId = getCookie('g_conversationId');
      const routeName = name ? name : this.$route.name;
      const log = `${sqeuenceNumber},${sessionId},${ALLROUTES[routeName]},${type}`;

      this.$Logan.log(log, 1);
      // 上报完sqeuenceNumber记录加1
      sessionStorage.setItem('sqeuenceNumber', sqeuenceNumber + 1);
    },
    // 上报日志
    async reportLog() {
      // beforDestory 上报日志
      const yestarday = dayjs(Date.now() - 24 * 60 * 60 * 1000).format(
        'YYYY-MM-DD'
      );
      const toDay = dayjs().format('YYYY-MM-DD');

      await this.$Logan.report({
        fromDayString: yestarday,
        toDayString: toDay,
        xhrOptsFormatter: (
          logItemStrings,
          logPageNo /* logPageNo starts from 1 */,
          logDayString
        ) => {
          return {
            reportUrl: '/s/',
            data: JSON.stringify({
              fileDate: logDayString,
              logArray: logItemStrings.toString(),
              logPageNo,
              /* ...Other properties you want to post to the server */
            }),
            withCredentials: false,
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              platform: 'web',
            },
            responseDealer: (xhrResponseText) => {
              if (xhrResponseText === 'well done') {
                return {
                  resultMsg: 'Report succ',
                };
              } else {
                return {
                  resultMsg: 'Report fail',
                  desc: 'what is wrong with this report',
                };
              }
            },
          };
        },
      });
    },
  },
};
